import React from 'react';
import moment from 'moment';
import { styledDefaultColDef, createAvatarNameRenderer } from '../../../extras/cellRenderers';
import { FreeUserActionCellRenderer } from './FreeUserActionCellRenderer';

const NameGetter = createAvatarNameRenderer(
  (p) => p?.data?.firstName,
  (p) => p?.data?.lastName
);

const getFullName = (params) => {
  return params?.data?.firstName
    ? params?.data?.firstName + ' ' + params?.data?.lastName
    : params?.firstName
    ? params?.firstName + ' ' + params?.lastName
    : '';
};

// const RegDateGetter = (params) => {
//   return (
//     <div className='flex items-center relative top-2'>
//       {moment(params.data?.createdOn).utc().format('DD/MM/YYYY')}
//       <span className='text-gray-400 ml-2'>
//         ({moment(params.data?.createdOn).utc().fromNow()})
//       </span>
//     </div>
//   );
// };

export const columnDefs = [
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
      valueGetter: (props) => getFullName(props.data),
    },
    valueGetter: (params) => {
      return getFullName(params);
    },
    width: 300,

    cellRenderer: NameGetter,
  },
  {
    headerName: 'Mobile No',
    field: 'phone',
    width: 200,
    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals'],
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>{params?.data?.phone}</div>
      );
    },
  },
  {
    headerName: 'Email',
    field: 'email',
    width: 250,

    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals'],
      valueGetter: (props) => getFullName(props.data),
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>{params?.data?.email}</div>
      );
    },
  },
  {
    headerName: 'Signup Date',
    field: 'signupDate',
    flex: 1,
    filter: 'agDateColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'greaterThan'],
    },

    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.createdOn
            ? moment(params?.data?.createdOn).format('DD MMM YYYY')
            : '-'}
        </div>
      );
    },
  },
  {
    headerName: 'Actions',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
    width: 100,
    cellRenderer: FreeUserActionCellRenderer,
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: false,
  sortable: false,
};
